export interface SupportTicketDisplayInput {
  id?: string;
  title?: string;
  linearIdentifier?: string;
  portalIssueReferenceId?: string;
}

function clean(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed || undefined;
}

/** Check whether a readable ticket identifier is already present in a title. */
function includesIdentifier(value: string, identifier: string | undefined): boolean {
  return Boolean(identifier && value.includes(identifier));
}

export function formatSupportTicketReference(ticket: SupportTicketDisplayInput | undefined | null): string | undefined {
  const linearIdentifier = clean(ticket?.linearIdentifier);
  const portalIssueReferenceId = clean(ticket?.portalIssueReferenceId);

  if (linearIdentifier && portalIssueReferenceId) {
    return `${linearIdentifier} ${portalIssueReferenceId}`;
  }
  return linearIdentifier || portalIssueReferenceId || clean(ticket?.id);
}

export function formatSupportTicketDisplayTitle(ticket: SupportTicketDisplayInput | undefined | null): string | undefined {
  const title = clean(ticket?.title);
  const linearIdentifier = clean(ticket?.linearIdentifier);
  const portalIssueReferenceId = clean(ticket?.portalIssueReferenceId);

  if (!title) {
    return formatSupportTicketReference(ticket);
  }

  const prefixedTitle = linearIdentifier && !includesIdentifier(title, linearIdentifier) ? `${linearIdentifier}: ${title}` : title;
  return portalIssueReferenceId && !includesIdentifier(prefixedTitle, portalIssueReferenceId)
    ? `${prefixedTitle} ${portalIssueReferenceId}`
    : prefixedTitle;
}
